import { ContentLayout } from '../../layout/ContentLayout';
import MakeCard from './MakeCard';

const MakesOverviewPage = () => {
  return (
    <ContentLayout>
      <MakeCard />
    </ContentLayout>
  );
};

export default MakesOverviewPage;
